"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledResponsiveFontSize = exports.FixedFontSize = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ResponsiveFontSize = _interopRequireDefault(require("../ResponsiveFontSize"));
var _formattedText = require("../../styles/formatted-text");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

//helpers

var FormattedText = _styledComponents["default"].div.withConfig({
  displayName: "styles__FormattedText",
  componentId: "sc-1olu0vu-0"
})(["", ";"], function (p) {
  return (0, _formattedText.getFormattedTextStyle)(p.isCompact);
});
var StyledResponsiveFontSize = exports.StyledResponsiveFontSize = FormattedText.withComponent(_ResponsiveFontSize["default"]);
var FixedFontSize = exports.FixedFontSize = (0, _styledComponents["default"])(FormattedText).withConfig({
  displayName: "styles__FixedFontSize",
  componentId: "sc-1olu0vu-1"
})(["font-size:", "rem;"], function (p) {
  return p.device === 'desktop' ? 1 : 0.75;
});
//# sourceMappingURL=styles.js.map